// extracted by mini-css-extract-plugin
export default {"containerPrices":"m8TzZ","expiredPrice":"r9QJw","actualPrice":"TA0JV","longPrice":"XFS9L","discount":"Esrlp","wrap":"A47cw"};